module.exports = __webpack_public_path__ + "static/img/pic-04.ae3c174.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/activity20250301/pic-04.jpg
// module id = tHBU
// module chunks = 0